namespace Matrix.Data {
    export interface SecurityRepairLogForm {
        SecMergeRowId: Serenity.IntegerEditor;
        FromSecurityId: Serenity.IntegerEditor;
        ToSecurityId: Serenity.IntegerEditor;
        ProcessedWhen: Serenity.StringEditor;
        ProcessedBy: Serenity.StringEditor;
        StdOut: Serenity.StringEditor;
        StdErr: Serenity.StringEditor;
        StatusCode: Serenity.StringEditor;
        RowId: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityRepairLogForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityRepairLog';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityRepairLogForm.init)  {
                SecurityRepairLogForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SecurityRepairLogForm, [
                    'SecMergeRowId', w0,
                    'FromSecurityId', w0,
                    'ToSecurityId', w0,
                    'ProcessedWhen', w1,
                    'ProcessedBy', w1,
                    'StdOut', w1,
                    'StdErr', w1,
                    'StatusCode', w1,
                    'RowId', w0,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
